import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/denver-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-denver-colorado",
      statusCode: 301,
    });
  },
});
